import { Column } from "@tanstack/react-table";

type ColumnMetaWithClassName = { className?: string };

export function columnClassName<T>(column: Column<T, unknown>): string {
  const meta = column.columnDef.meta as ColumnMetaWithClassName | undefined;
  return meta?.className ?? "";
}
